import { defineComponent as I, ref as r, useCssModule as q, watch as C, onMounted as K, onBeforeUnmount as R, computed as U, withDirectives as _, createElementBlock as k, openBlock as m, renderSlot as x, createVNode as E, createElementVNode as b, normalizeClass as S, createBlock as V, createTextVNode as W, toDisplayString as Y, Transition as F, withCtx as j, normalizeStyle as G, unref as M, vShow as H, nextTick as A } from "vue";
import { KEY_CODES as f } from "./constants.js";
import J from "./directives/clickoutside.js";
import Q from "./utils/calculateElementOverflow.js";
import { getMountPoint as X } from "./utils/helpers.js";
import B from "./Icon.js";
import { _ as Z } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const ee = ["aria-expanded"], te = {
  key: 0,
  class: "tw-flex tw-items-center tw-font-medium tw-text-blue-500 hover:tw-text-blue-700"
}, le = /* @__PURE__ */ I({
  name: "ll-dropdown",
  __name: "Dropdown",
  props: {
    align: { default: "right" },
    label: { default: "" },
    closeManually: { type: Boolean, default: !1 },
    offset: { default: () => ({}) },
    reattach: { type: Boolean, default: !0 },
    contentClass: { default: "" },
    fluidContent: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "dismiss"],
  setup(D, { expose: $, emit: L }) {
    const a = D, p = L, t = r(null), w = r(null), d = [], s = r(d), i = r(-1), l = r(!1), g = r({}), T = q();
    C(l, (e) => {
      e || (i.value = -1), p("toggle", e);
    }), C(i, (e, o) => {
      e in s.value && s.value[e].classList.add("tw-bg-ice-200"), o in s.value && s.value[o].classList.remove("tw-bg-ice-200");
    }), K(() => {
      var e, o, n;
      if (a.reattach) {
        const c = X();
        t.value && c.appendChild(t.value);
      }
      (e = t.value) != null && e.querySelector(".stash-menu") ? s.value = ((o = t.value) == null ? void 0 : o.querySelectorAll(".stash-menu-item")) ?? d : s.value = ((n = t.value) == null ? void 0 : n.querySelectorAll(".dropdown__item")) ?? d, window.addEventListener("resize", () => u());
    }), R(() => {
      var e, o;
      window.removeEventListener("resize", () => u()), (o = (e = t == null ? void 0 : t.value) == null ? void 0 : e.parentNode) == null || o.removeChild(t.value);
    });
    function u(e) {
      var n;
      if (a.closeManually && ((n = t.value) != null && n.contains(e == null ? void 0 : e.target) || t.value === (e == null ? void 0 : e.target)))
        return;
      const o = l.value;
      l.value = !1, o && p("dismiss");
    }
    async function v() {
      var e;
      l.value ? l.value = !1 : (l.value = !0, await z(), (e = t.value) == null || e.focus());
    }
    function N(e) {
      if (e.keyCode === f.ESCAPE)
        u();
      else if (e.keyCode === f.DOWN && i.value < s.value.length - 1 && l.value)
        i.value++;
      else if (e.keyCode === f.UP && i.value > -1 && l.value)
        i.value--;
      else if (e.keyCode === f.ENTER && i.value !== -1 && l.value)
        s[i.value].click();
      else
        return;
      e.preventDefault();
    }
    function O() {
      var e;
      (e = t.value) == null || e.style.setProperty("--offset", "0");
    }
    async function z() {
      var y, h;
      await A();
      const e = ((y = w.value) == null ? void 0 : y.getBoundingClientRect()) || {}, o = e.top + e.height, n = {
        x: 0,
        y: 0,
        ...a.offset
      };
      a.reattach && (g.value = {
        left: a.align === "left" ? `${Math.round(e.left) + n.x}px` : void 0,
        right: a.align === "right" ? `${document.documentElement.clientWidth - Math.round(e.right) + n.x}px` : void 0,
        top: `${window.scrollY + o + n.y}px`
      }, await A());
      const c = Q(t == null ? void 0 : t.value);
      if (c) {
        const P = a.align === "left" ? "-" : "";
        (h = t.value) == null || h.style.setProperty("--offset", `${P}${c.value}`);
      }
    }
    return $({
      isActive: U(() => l.value),
      toggle: v,
      dismiss: u
    }), (e, o) => _((m(), k("div", {
      ref_key: "dropdownRef",
      ref: w,
      class: "tw-relative tw-inline-block",
      "data-test": "ll-dropdown",
      onKeydown: N
    }, [
      x(e.$slots, "toggle", {
        isActive: l.value,
        toggle: v
      }, () => [
        b("button", {
          "data-test": "button|toggle",
          "aria-expanded": l.value,
          class: S([e.label ? "tw-min-w-auto tw-outline-none" : "tw-rounded tw-p-3"]),
          onClick: v
        }, [
          e.label ? (m(), k("span", te, [
            W(Y(e.label) + " ", 1),
            E(B, { name: "caret-down" })
          ])) : (m(), V(B, {
            key: 1,
            name: "ellipsis"
          }))
        ], 10, ee)
      ]),
      E(F, {
        name: "fade",
        onAfterLeave: O
      }, {
        default: j(() => [
          _(b("div", {
            ref_key: "contentRef",
            ref: t,
            "data-test": "ll-dropdown-content",
            class: S([
              M(T).content,
              e.contentClass,
              {
                "tw-left-0 after:tw-left-6": a.align === "left",
                "tw-right-0": a.align === "right",
                "tw-max-w-[360px]": !a.fluidContent
              }
            ]),
            style: G(g.value)
          }, [
            x(e.$slots, "default", {
              dismiss: u,
              isActive: l.value
            })
          ], 6), [
            [H, l.value]
          ])
        ]),
        _: 3
      })
    ], 32)), [
      [M(J), u]
    ]);
  }
}), oe = "_content_zbxyu_2", ae = {
  content: oe
}, ne = {
  $style: ae
}, ve = /* @__PURE__ */ Z(le, [["__cssModules", ne]]);
export {
  ve as default
};
//# sourceMappingURL=Dropdown.js.map
